

import { useState } from 'react';

export default function HeroSection() {
  const [isHovered, setIsHovered] = useState(false);

  const scrollToForm = () => {
    const formSection = document.getElementById('pricing-section');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-50">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Beautiful%20fit%20woman%20in%20elegant%20purple%20athletic%20wear%20doing%20workout%20in%20a%20modern%20minimalist%20gym%20with%20soft%20purple%20lighting%2C%20professional%20fitness%20photography%2C%20clean%20aesthetic%2C%20feminine%20and%20empowering%20atmosphere%2C%20high%20quality%20portrait&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
        }}
      />
      
      {/* Purple Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-100/30 to-transparent" />
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left space-y-8">
            <div className="inline-flex items-center px-4 py-2 bg-purple-100 rounded-full">
              <i className="ri-star-fill text-yellow-500 mr-2"></i>
              <span className="text-purple-800 font-medium text-sm font-poppins">Programa Oficial 30 Dias</span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 leading-tight font-montserrat">
              Transforme seu corpo em <span className="text-purple-600">30 dias</span> com a Atleta{' '}
              <span className="text-purple-600">Raíssa Bernardo</span>
            </h1>
            
            <p className="text-xl text-gray-700 leading-relaxed max-w-2xl font-inter">
              Planilha de treino estratégico, organizado e totalmente personalizado para mulheres que querem evoluir de verdade — com treino, constância e resultados reais.
            </p>
            
            <button
              onClick={scrollToForm}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              className={`inline-flex items-center px-8 py-4 bg-purple-500 hover:bg-purple-600 text-white font-semibold rounded-full transition-all duration-300 transform ${
                isHovered ? 'scale-105 shadow-lg' : 'shadow-md'
              } whitespace-nowrap cursor-pointer font-poppins`}
            >
              <i className="ri-arrow-right-line mr-2"></i>
              Quero Minha Consultoria Agora
            </button>
            
            <div className="flex items-center space-x-6 pt-4">
              <div className="flex items-center">
                <div className="flex -space-x-2">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="w-10 h-10 rounded-full bg-purple-200 border-2 border-white flex items-center justify-center">
                      <i className="ri-user-3-fill text-purple-600"></i>
                    </div>
                  ))}
                </div>
                <span className="ml-3 text-gray-600 font-inter">+300 mulheres transformadas</span>
              </div>
            </div>
          </div>
          
          {/* Right Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://static.readdy.ai/image/557dfd3dbeb95a5202c98a2c6d1e7295/a6082b2f82bbfc9c0a574d69fe553537.jpeg"
                alt="Raíssa Bernardo - Personal Trainer e Atleta Wellness"
                className="w-full max-w-md mx-auto rounded-2xl shadow-2xl object-cover object-top"
              />
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 bg-white rounded-full p-4 shadow-lg">
                <i className="ri-trophy-fill text-yellow-500 text-2xl"></i>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-purple-500 text-white rounded-full p-4 shadow-lg">
                <i className="ri-heart-pulse-fill text-2xl"></i>
              </div>
            </div>
            
            {/* Background Decoration */}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-200 to-purple-300 rounded-2xl transform rotate-6 -z-10"></div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-purple-500 text-2xl"></i>
      </div>
    </section>
  );
}

